module.exports = __webpack_public_path__ + "img/loader.1d8e2ff6.svg";